import * as React from 'react';
import Typography from '@mui/material/Typography';
import {Box, Paper, Button} from '@mui/material';
import {EditCalendar} from "@mui/icons-material";
import {styled} from "@mui/material/styles";
import {addToCalendar, getDayName, getEventTimeString, isDateToday, orange, getMonthName} from "../utils";
// import DirectionsIcon from '@mui/icons-material/Directions';
import LocationOnIcon from '@mui/icons-material/LocationOn';
// import MyLocationIcon from '@mui/icons-material/MyLocation';
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import EventAvailableIcon from '@mui/icons-material/EventAvailable';

const DemoPaper = styled(Paper)(({theme}) => ({
    marginBottom: theme.spacing(4),
    minHeight: 100,
    borderRadius: '10px',
    border: '1px solid #0000004c',
    ...theme.typography.body2,
    textAlign: 'center',
    justifySelf: "center",
}));

const getMonth = (eventDate) => {
    const date = new Date(eventDate);
    const month = getMonthName(date.getMonth());
    return (month)
}

export default function EventCardsMobile({event, showLocation}) {
    const isToday = React.useMemo(() => {
        return isDateToday(event.date);
    }, [event.date]);
    const handleAddressClick = React.useCallback(() => {
        if (!event.location.cords?.length) return;
        showLocation(event.location);
    }, [event.location, showLocation]);

    return (
        <DemoPaper
            square={false}
            variant="elevation"
            sx={{
                display: "block",
                width: {lg: "50%", md: "50%", sm: "80%", xs: "100%"},
            }}
        >
            <Box sx={{backgroundImage:"url(../events/abc.png)", paddingX: 2, paddingY: 2, borderTopRightRadius: "10px", borderTopLeftRadius: "10px"}}>
                <Box sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                    {event.endDate ? (
                        <Typography variant="h6" component="div" style={{color: isToday ? "#112A46" : "#112A46"}}>
                            {`${event.startDate.getDate()} ${getMonth(event.startDate)} `}
                            to {`${event.date.getDate()} ${getMonth(event.date)} `}
                        </Typography>
                    ) : (
                        <Typography variant="h6" component="div" style={{color: isToday ? "#112A46" : "#112A46"}}>
                            {`${getDayName(event.date.getDay())}, ${event.date.getDate()} ${getMonth(event.date)} `}
                        </Typography>
                    )}
                    <Typography variant="h6" component="div" style={{color: isToday ? "#112A46" : "#112A46", fontSize: '0.8rem'}}>
                        <AccessTimeIcon sx={{
                            color: isToday ? orange[600] : "rgba(0, 0, 0,0.7)",
                            verticalAlign: "middle",
                            fontSize: "0.8rem",
                            marginRight: 0.7,
                        }}/>
                        {getEventTimeString(event)}
                    </Typography>
                    {/* <EventAvailableIcon fontSize="medium" onClick={() => addToCalendar(event)} sx={{color: isToday ? '#005dff': "#005dff"}}/> */}
                </Box>
                <Typography
                    variant="h6"
                    component="div"
                    style={{
                        fontWeight: '600',
                        fontSize: "1rem",
                        color: "#01178d",
                        fontFamily: "inherit",
                        letterSpacing: "0.06rem",
                        textAlign: "left",
                        marginTop: "10px",
                        marginBottom: "10px"
                    }}
                >
                    {event.eventName}
                </Typography>
                <Box sx={{display: 'flex', alignItems: 'flex-start', flexDirection: 'column'}}>
                    <div style={{display: "flex", marginTop: "2px"}}>
                        <LocationOnIcon
                            sx={{
                                color: isToday ? orange[600] : "rgba(0, 0, 0,0.7)",
                                verticalAlign: "flex-end",
                                fontSize: "14px",
                                marginRight: 0.7,
                                marginTop: "8px",
                                alignSelf: "baseline"
                                
                            }}
                        />
                        <Typography
                            variant="body2"
                            
                            color="text.secondary"
                            style={{textAlign: 'left', paddingRight: "5px", color: "#020a13", marginBottom:"5px",marginTop:"5px",fontWeight:"500"}}
                        >
                            {event.location.address}
                        </Typography>
                    </div>
                    <div style={{display: "flex", marginTop: "2px"}}>
                        <LocalPhoneIcon
                            sx={{
                                color: isToday ? orange[600] : "rgba(0, 0, 0,0.7)",
                                verticalAlign: "flex-end",
                                fontSize: "14px",
                                marginRight: 0.7,
                                marginTop: "4px",
                            }}
                        />
                        <Typography
                            variant="body2" 
                            style={{textAlign: 'left'}}
                        >
                            {event.location.phone?.split(",").map((n, i) => (
                            <a style={{textDecoration: "none", color: "#01178d", letterSpacing:"1px"}} href={`tel:${n}`} key={n}>
                                {i > 0 ? "," : ""}{n}
                            </a>
                        ))}
                        </Typography>
                        
                    </div>
                </Box>
            </Box>

            <Box sx={{display: 'flex', alignItems: 'flex-start', flexDirection: 'column', paddingX: 2, paddingY: 2}}>
                <div dangerouslySetInnerHTML={{__html: event.description}} style={{
                    textAlign: 'left',
                    fontSize: "0.8rem",
                    color: "black",
                    lineHeight: "1.8",
                    marginTop: "10px"
                }}/>
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        width: "100%",
                        flexDirection: {xs: 'column', sm: 'row'},
                        paddingBottom: "10px",
                        marginTop: "20px"
                    }}
                >
                    <Button
                        variant="contained"
                        sx={{marginTop: "10px"}}
                        startIcon={<LocationOnIcon />}
                        onClick={handleAddressClick}
                        style={{borderRadius: "10px", color:"#112A46", backgroundColor:"#fad03b", letterSpacing:"1.5px"}}
                    >View Location</Button>
                    
                    <Button
                        variant="outlined"
                        sx={{marginTop: "15px", boxShadow:2}}
                        startIcon={<EventAvailableIcon />}
                        onClick={() => addToCalendar(event)}
                        style={{borderRadius: "10px", letterSpacing:"1px"}}
                    >Add to Calendar</Button>
                </Box>

            </Box>
            {/*
            <Box sx={{ display: 'flex', alignItems: 'flex-start', mt: 2 }}>
                <Box sx={{ flexGrow: 1 }} />
                {event.location.cords?.length ?
                    <LocationOnIcon
                        fontSize="medium"
                        onClick={handleAddressClick}
                        sx={{color: isToday ? '#005dff': "#057be4"}}
                    /> : ""
                }
            </Box>
            */}
        </DemoPaper>
    );
}